// extracted by mini-css-extract-plugin
export default {"footer":"f7tE2g","left":"p0GeFl","cancelButton":"IGa19k"};